import { theme } from '@cloudinary/url-gen/actions/effect';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Avatar,
  Typography,
  useTheme,
  Link,
  Container,
  Button,
  Grid,
  Box,
} from '@mui/material';
import { DbLeagueTeam, DbTeamMembers } from '@par/shared/types/league';
import React, { useEffect, useState } from 'react';
import { resizeImage } from '../../api/cloudinary';
import { fetchGet } from '@par/shared/api/common';
import { StyledPaperItem } from '../../common/mui-components';
import { LeagueLobby } from './LeagueLobby';
import './styles.css';
import { useNavigate } from 'react-router-dom';

export const LeagueTeams = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [teams, setTeams] = useState<DbLeagueTeam[]>();
  const [teamMembers, setTeamMembers] = useState<DbTeamMembers[]>();

  useEffect(() => {
    fetchAllTeams();
  }, []);

  const fetchAllTeams = async () => {
    const res = await fetchGet(`/league/teams/all`);
    console.log('res', res);
    setTeams(res.teams);
    setTeamMembers(res.members);
  };

  const handleUsernameClick = async (e: any, profileId: string) => {
    e.stopPropagation();
    navigate(`/profile/overview/${profileId}`);
  };

  const getTeamMember = (profileId: string) => {
    if (!teamMembers) return <></>;
    const found = teamMembers.find((tm) => tm._id === profileId);
    if (!found) return <></>;
    return (
      <Stack direction={'row'} spacing={1} justifyContent={'center'} px={2}>
        <Avatar
          src={resizeImage(found.avatarPublicId, 50, 50)}
          variant="rounded"
          sx={{
            height: 35,
            width: 35,
          }}
        />
        <Link
          component="button"
          onClick={(e) => handleUsernameClick(e, profileId)}
          textAlign={'left'}
        >
          <Typography
            sx={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: 180,
            }}
          >
            {' '}
            {found.username}
          </Typography>
        </Link>
      </Stack>
    );
  };

  return (
    <Container sx={{ paddingBottom: 20 }}>
      <Grid container spacing={2}>
        <Grid item sm={12} md={12}>
          <Typography variant="h5led" textAlign={'center'} letterSpacing={5}>
            TEAMS
          </Typography>
        </Grid>
        <Grid item sm={12} md={12}>
          <Typography textAlign={'center'} letterSpacing={5}>
            PILOT SEASON
          </Typography>
        </Grid>
        {teams?.map((t) => (
          <Grid item sm={3} md={3}>
            <Stack>
              <Box
                className="team-background"
                display="flex"
                justifyContent={'center'}
                alignItems={'center'}
                sx={{
                  height: 160,
                  border: '1px solid',
                  borderBottom: 'none',
                  borderColor: '#696969',
                  borderRadius: '10px 10px 0 0',
                }}
              >
                <Avatar
                  src={resizeImage(t.avatarPublicId, 200, 200)}
                  variant="rounded"
                  sx={{ width: 150, height: 150 }}
                />
              </Box>
              <Box
                display="flex"
                justifyContent={'center'}
                alignItems={'center'}
                sx={{
                  height: 50,
                  border: '1px solid',
                  borderBottom: 'none',
                  borderColor: '#696969',
                }}
              >
                <Typography
                  variant="body1led"
                  textAlign={'center'}
                  fontWeight={600}
                  letterSpacing={2}
                  sx={{
                    borderBottom: '1px solid',
                    borderColor: 'white',
                  }}
                >
                  {t.teamName.toUpperCase()}
                </Typography>
              </Box>
              <Stack
                py={2}
                spacing={1}
                sx={{
                  border: '1px solid',
                  borderTop: 'none',
                  borderColor: '#696969',
                  borderRadius: '0 0 10px 10px',
                }}
              >
                {t.members.map((m) => getTeamMember(m))}
              </Stack>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
